import React, { useState } from "react";
import { Modal, Tooltip } from 'antd';
import styles from "./scss/favList.module.scss";
//*import userimg from "../../../styles/images/1a.png";
//*import { StatusTag } from "../../../shared/widgets/statusTag";
//*import statusimg from "../../../../src/styles/images/profile-status-icon.svg";
import {URButton} from "../../../shared/widgets/button";
//*import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
//*import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import {
  filterFavouriteCalls,
  max_Call_Window,
  toastInformation
} from "../../../base/callService/common";
import { getCallHistoryByExt } from "../../../base/callService/callsApiService";
import { useHistory } from "react-router-dom";
import { initiateCall, sendDirectVideoCallRequest } from "../../../base/callService/callService";
import { ChatService } from "../../../base/chatService";
import PopoverModule from "../callsWidgets/PopoverModule/PopoverModule";
import { storeCallHistory, storeChatWindow, storeParticularLog } from "../../../base/callService/store_mining";
import store from "../../../context/store/store";
// const menu1 = (
//   <Menu>
//     <Menu.Item>Until 8:00 AM</Menu.Item>
//     <Menu.Item>1 Hr</Menu.Item>
//     <Menu.Item>12 Hrs</Menu.Item>
//     <Menu.Item>1 Week</Menu.Item>
//     <Menu.Item>Always</Menu.Item>
//   </Menu>
// );

export default function FavLists() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { callReducer }: initialStateModel = useSelector((state: initialStateModel) => state);

  let  favList = filterFavouriteCalls(callReducer.logs);
  const history = useHistory();
  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  // const handleOk = () => {
  //   setIsModalVisible(false);
  // };


  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // const filtermenu = (
  //   <Menu>
  //     <Menu.Item>Missed</Menu.Item>
  //     <Menu.Item>Incoming</Menu.Item>      
  //     <Menu.Item>Outgoing</Menu.Item>      
  //   </Menu>
  // );

  // const menu = (
  //   <Menu>
  //     <Menu.Item>Mark as Read</Menu.Item>
  //      {/* <Menu.Item>Mark as Unread</Menu.Item> */}
  //     <Menu.Item onClick={showModal}>Delete</Menu.Item>
  //   </Menu>
  // );

  const callDetailPage = (list: object) => {
    let {isProfileView}=store.getState().updatedCallList||{};
    if(isProfileView===true){storeChatWindow(list)}
    storeCallHistory([]);
    storeParticularLog(list,false);
    getCallHistoryByExt(1);
    max_Call_Window();
  };
  var len = Math.round((favList?.length / 8));
  var random_color = Array(len).fill([1,2,3,4,5,6,7,8]).flat();

const videoCallTrigger = (data:any) =>{
  if(data?.ext) { 
    sendDirectVideoCallRequest(data);  
}
  else { toastInformation("Please check the number","failure"); }
}

  return (
    <>
      <div className={`scrollerhover ${styles.recentListmain}`}>
        {favList?.length > 0 && favList?.map((list: any, index: any) => {

          return <div key={index}>
            <div className={`${styles.profilelists} ${styles.unreads}`}>
              <PopoverModule  popOverValues={list} randomColor={random_color[index]} value={false}/>
              <div className={styles.vmsideDetails} onClick={(e: any) => callDetailPage(list)}>
                <div className={styles.frow}>
                  {/* <span >{list.time}</span> */}
              
                  <h4>{list?.caller_id }</h4>
                
                </div>
                <div className={styles.secondrow}>
                  <p></p>
                  {/* <p><span
                    className={list?.callType === "OUTBOUND" ? styles.outGoingCall
                      : (list?.callType === "INBOUND" ? styles.incomingCall
                        : styles.missedCall)}></span>
                        
                  <span className={list.callType === "missedcall" ?
                          `${styles.callSts} ${styles.callMissed}` : styles.callSts}>
                          
                    {list.callType === "OUTBOUND" ? "Outgoing" :
                      (list.callType === "INBOUND" ? "Incoming" : "Missed")}</span>
                  <span className={styles.callDuration}>{ milliSecondsConverter(list.callDuration)}</span></p> */}
                </div>
                <div className={styles.hoverdiv}>
                  <ul>
                    <li><Tooltip placement="top" title="Call"><span className={styles.iconCall}
                      onClick={() => initiateCall(list.ext, 'audio')}></span></Tooltip></li>
                    <li><Tooltip placement="top" title="Chat"><span className={styles.iconChat}
                      onClick={() => ChatService.openChatWindow(list, history)}></span></Tooltip></li>
                    <li   onClick={() => videoCallTrigger(list)}><Tooltip placement="top" title="Video Call">
                      <span className={styles.iconMeet}></span></Tooltip></li>
                  </ul>
                </div>
              </div>
            </div>


          </div>;
        })}

      </div>

      <Modal visible={isModalVisible} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} />
        <h2>Delete this Chat?</h2>
        <p>You cannot retrieve the chat history with UI Designing after deletion</p>
        <div className={styles.footersection}>
          <URButton className={styles.cancelbtn} name="Cancel"></URButton>
          <URButton className={styles.deletebtn} onClick={handleCancel} name="Delete Chat"></URButton>
        </div>
      </Modal>


    </>
  );
};

  
